import {createStore} from "vuex";

import messages from "./modules/messages.js";
import user from "./modules/user.js";
import devoirs from "./modules/devoirs.js";
import classes from "./modules/classes.js";
import {auth} from "./modules/auth.module.js";
import message from "./message";
import noteDetail from "./modules/noteDetail.js";
import enseignant from "./modules/enseignant.js";
import eleve from "./modules/eleve.js";

export default createStore({
  modules: {
    auth,
    messages,
    user,
    devoirs,
    classes,
    message,
    noteDetail,
    enseignant,
    eleve,
  },
});
